import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { delay, Observable, of, tap } from 'rxjs';
import { IProveedoresEelement } from '../../interfaces/proveedores';
import { environment } from '../../../environments/environment';

let ELEMENT_DATA: IProveedoresEelement[] = [];

@Injectable({
  providedIn: 'root'
})
export class ComprasService {

  constructor(private http:HttpClient ) {

  }
  
  getLength(filter: string) {
    return of(this.getElement('').length)
      .pipe(delay(500), tap(_ => {  }));
  }

  getData(page: number, pageSize: number) {
    const factor = 0
    return factor ? of(this.getElement('')
      .slice((page - 1) * pageSize, page * pageSize)).pipe(
        delay(500), tap(_ => { })) :
      of(this.getElement('')
        .slice((page - 1) * pageSize, page * pageSize)).pipe(
          delay(500), tap(_ => { }))
  }

  getElement(filter: string) {
    return !filter ? [...ELEMENT_DATA] : ELEMENT_DATA.filter(x => x.folio.indexOf(filter) >= 0)
  }

  setData(body: any) {
    ELEMENT_DATA = []
    ELEMENT_DATA = body
  }

  getInfo(){
    return this.data
  }

  data = []
  
  getUserData(id){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}configUserId/${id}`);
  }

  getDetapartamentos(){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}catDepartamento`);
  }

  getConceptosPorDepartamento(id, tipoGasto: string){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}conceptosCuenta/${id}/${tipoGasto}`);
  }

  getConceptos(idSolicitante: number, tipoGasto: number){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}Select-ConceptosxSolicitante/${idSolicitante}/${tipoGasto}`);
  }

  getCentrosDeCosto(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}seleccionCentrosDeCosto`, body);
  }

  getSolicitudesCompra(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}datosSolicitudBusqueda`, body);
  }

  getSolicitudesPreOrdenCompra(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}busquedaSolicitudesAprobadas`, body);
  }

  getListadoOrdenesCompra(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}busqueda_OrdenesdeCompra`, body);
  }

  postSolicitud(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}altaSolicitud`, body);
  }

  updateSolicitudCompra(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}updateSolicitud`, body);
  }

  getAreasSolicitantes(){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}areasSolicitantes`);
  }

  getEstatusSolicitudes(){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}selectEstatusSolicitud`);
  }

  getEstatusConceptos(){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}selectEstatusConceptos`);
  }

  getEstatusConceptosByPerfil(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}Estatus-Conceptos-Perfil`,body);
  }

  getSolicitudDetalle(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}datosSolicitudEditar`, body);
  }

  aprobarSolicitudCompra(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}aprobarSolicitud`, body);
  }

  importarPlantillaConceptos(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}importarPlantilla`, body);
  }

  descargarReporteSolicitudes(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}downloadRptSolicitud`, body);
  }

  getSolicitudPreCompraDetalle(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}seleccionConceptosPreOrdenCompra`, body);
  }

  getProveedores(){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}obtenerProveedores`);
  }

  getDirecciones(id){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}obtenerSucursales/${id}`);
  }

  postSolicitudPreOC(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}registrarPreOrdenCompra`, body);
  }

  guardarCambiosOCAutorizaor(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}insertOrdenCompra`, body);
  }

  guardarCambiosOCAutorizaorOperativo(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}AprobarPreOrdenCompraporOperativo`, body);
  }
  
  obtenerOrdenCompra(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}mostrar_DetalleOrdenCompra`, body);
  }

  getTiposGastos() {
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}tipoGasto`);
  }

  getTypesRepairs() {
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}tipoReparacion`);
  }

  getVehiclesPlates(){
     return this.http.get<any>(`${environment.base}${environment.catalogos_port}vehiculoPlacas`);
  }

  guardarCambiosConRestricciones(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}Aprobar-SolicitudConRestriccion`, body);
  }

  getValidaProveedorTieneTasas(idProveedor: number){
    return this.http.get<any>(`${environment.base}${environment.catalogos_port}ValidaExisteImpuestosProveedor/${idProveedor}`);
  }

  obtenerDocumentosACargar(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}Obtener-DocumentosPreOrden`, body);
  }

  obtenerEstatusByTipo(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}EstatusPre_OrdenCompra`, body);
  }
  
  cancelarSolicitudCompra(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}CancelarSolicitud`, body);
  }

  getListaProveedores(){
   return this.http.get<any>(`${environment.base}${environment.catalogos_port}listadoProveedoresSolicitud`);
  }

  validaDocumentosRequeridosPreOrden(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}Valida-DocumentosRequeridosPreOrden`, body);
  }

  //////////// ORDEN DE COMPRA //////////

  getEvidenciasOrdenDeCompra(idOrdenCompra: number){
     return this.http.get<any>(`${environment.base}${environment.catalogos_port}ObtenerDocumentosEvidenciaCompras/${idOrdenCompra}`);
  }

  guardarEvidenciasOc(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}RegistrarEvidenciasOrdenCompra`, body);
  }

  actualizarOrdenCompra(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}ActualizarOrdenCompra`, body);
  }

  aprobarRechazarOrdenCompra(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}AutorizaRechazarOCporOperativo`, body);
  }

  cargarFacturasOrdenCompra(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}CargarXMLFactura`, body);
  }

  generarPdfOrdenCompra(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}Generar_PdfOrdenCompra`, body);
  }

  guardarRelacionesConceptos(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}Registrar_RelacionOCFactura`, body);
  }

  cancelarPreOrdenCompra(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}Cancelar-PreOrdenCompra`, body);
  }


 /* Origen
  1 = solicitud,
  2 = pre orden,
  3 = oc
*/
  getTimeLineSolicitudes(id: number, codigo?: string, origen?: number){
     return this.http.get<any>(`${environment.base}${environment.catalogos_port}TimeLine_SolicitudCompra_OrdenCompra/${id}/${codigo}/${origen}`);
  }

descargarArchivoBlob(blobFileId: number) {
  return this.http.get(
    `${environment.base}${environment.catalogos_port}DownloadFile/${blobFileId}`,
    {
      responseType: 'blob'
    }
  );
}

  crearAnticipo(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}Crear-Anticipo`, body);
  }

  listadoAnticipos(body){
    return this.http.post<any>(`${environment.base}${environment.catalogos_port}Listado-Anticipos`, body);
  }
}